<script lang="ts" setup>
import { useI18n } from "vue-i18n"
import { ref, useTemplateRef } from "vue"
import * as _ from "lodash-es"

// Types
import { IrveFormProfileRow } from "@types"

// Components

type Props = {
    visible: boolean
    utilisationProfile?: IrveFormProfileRow[]
}
const props = withDefaults(defineProps<Props>(), {
    visible: true,
    utilisationProfile: () => [
        {
            periods: [],
            days: [],
            foisonnement: undefined,
        },
    ],
})
const emit = defineEmits(["close", "update:utilisationProfile"])

//=============================================================================//
//                               Lang
//=============================================================================//
const { t } = useI18n({
    messages: {
        fr: {
            confirm: "Valider",
            leave: "Quitter",
            title: "Profil d'utilisation",
        },
    },
})

const modelValue = ref<IrveFormProfileRow[]>([
    {
        periods: [],
        days: [],
        foisonnement: undefined,
    },
])

const formRef = useTemplateRef("formRef")
/**
 * Quand l'utilisateur valide le formulaire
 */
const onClickSubmit = async () => {
    if (formRef.value) {
        if ((await formRef.value.validate()) === true) {
            emit(
                "update:utilisationProfile",
                _.cloneDeep([...modelValue.value])
            )
            emit("close")
        }
    }
}

/**
 * Quand la modale s'affiche, on copie la valeur du profil d'utilisation pour pouvoir le modifier
 */
function onShowDialog() {
    modelValue.value = _.cloneDeep([...props.utilisationProfile])

    if (modelValue.value?.length === 0) {
        modelValue.value.push({
            periods: [],
            days: [],
            foisonnement: undefined,
        })
    }
}
</script>
<template>
    <BaseDialog
        :visible="visible"
        modal
        position="top"
        :closable="false"
        :style="{ maxWidth: '52rem' }"
        :breakpoints="{ '1199px': '75vw', '575px': '80vw' }"
        @hide="$emit('close')"
        @show="onShowDialog"
    >
        <div
            class="utilisation-profile-modal flex flex-col justify-between gap-10"
        >
            <!-- Header -->
            <h1 class="self-center text-xl font-bold">
                {{ t("title") }}
            </h1>
            <!-- Liste des formulaires-->
            <UtilisationProfileForm ref="formRef" v-model="modelValue" />
            <!-- Footer -->
            <div class="flex justify-between">
                <BaseButton
                    :label="t('leave')"
                    variant="text"
                    @click="$emit('close')"
                ></BaseButton>
                <BaseButton
                    :label="t('confirm')"
                    @click="onClickSubmit"
                ></BaseButton>
            </div>
        </div>
    </BaseDialog>
</template>
